import * as React from 'react';
import {Card, CardContent, Typography, Box} from '@mui/material';
import {useRecordContext, useTranslate} from 'react-admin';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import {Order} from '../types';
import {useTheme} from '@mui/material/styles';

export const AsideAddressWarning = () => {
    const translate = useTranslate();
    const record = useRecordContext<Order>();
    const theme = useTheme();
    if (!record || record.validAddress !== false) {
        return null;
    }

    return (
        <Box mt={{xs: '20px', md: '0'}} ml={{xs: '0', md: '20px'}} width={{xs: '100%', md: '90%'}}>
            <Card
                sx={{
                    backgroundColor: theme.palette.info.light,
                    color: theme.palette.info.contrastText,
                    marginTop: 2,
                }}
            >
                <CardContent>
                    <Box display="flex" alignItems="center" mb={1}>
                        <ErrorOutlineIcon sx={{marginRight: 1}}/>
                        <Typography variant="h6" component="div">
                            {translate('resources.order.address_warning.title')}
                        </Typography>
                    </Box>
                    <Typography variant="body2" component="div">
                        {translate('resources.order.address_warning.content')}
                    </Typography>
                    {record.addressValidation && record.addressValidation.length > 0 ? (
                        <Box mt={2}>
                            <Typography variant="subtitle2">
                                {translate('resources.order.address_warning.issues_detected')}:
                            </Typography>
                            {record.addressValidation.map((issue, index) => (
                                <Typography key={index} variant="body2">{issue.message}</Typography>
                            ))}
                        </Box>
                    ) : (
                        <Box mt={2}>
                            <Typography variant="subtitle2">
                                {translate('resources.order.address_warning.unknown_error')}
                            </Typography>
                        </Box>
                    )}
                </CardContent>
            </Card>
        </Box>
    );
};
